import React, { Component } from "react";

//components
import Stepper from "../../../../generic_components/components/stepper/Stepper";

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../../functions/generic_functions"

//router
import { withRouter } from 'react-router-dom';

//static routes
import {
    cari_app_form_url,
    cari_api_save_form_page_base_url,
} 
from "../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    openCariModal,
    resetCariActiveData,
    setCariActiveUserData
} from "../../../../redux/actions/indexActions";

//redux mapper
const mapStateToProps = state => {
    return {
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData,
        activeUserData: state.cariReducer.activeUserData,
        activePositionData: state.cariReducer.activePositionData,
        activeApplicationData: state.cariReducer.activeApplicationData,
        cariPage1Data: state.cariReducer.cariPage1Data,
        cariPage2Data: state.cariReducer.cariPage2Data,
        cariPage3Data: state.cariReducer.cariPage3Data,
        cariPage4Data: state.cariReducer.cariPage4Data,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
        setCariActiveUserData: (user_data) => {
            dispatch(setCariActiveUserData(user_data))
        },
    };
};

/*
    props: 
        page_num => page number of cari form
*/

class CariAppFormStepper extends Component {

    state = {
        mounted: false,
        stepperOptions: [
            {
                label: "Personal Information",
                index: 1,
            },
            {
                label: "References",
                index: 2,
            },
            {
                label: "Document Upload",
                index: 3,
            },
            {
                label: "Submit",
                index: 4,
            },
        ],
    }

    constructor(props) {
        super(props);

        //action handlers
        this.handleOnClickSavePageData = this.handleOnClickSavePageData.bind(this);
    }


    /*
        post parameters {
            application_id,
            email,
            token, //TODO remove after
            postData,
        }

        return data {
            status => true/false
            message {
                saveComplete = true/false
            }
        }
    */
    handleOnClickSavePageData(nextPageNum) {

        //current page num
        var currentPageNum = this.props.page_num;

        //get next page url
        var subsequentUrl = cari_app_form_url + "/" + nextPageNum;

        //if the application completion status is "Complete", skip save page
        if (this.props.activeApplicationData.application_status === "Complete") {
            this.props.history.push(subsequentUrl);
            return;
        }

        //if page 3, skip and go to next link
        if (currentPageNum === 3) {
            //redirect to next page
            this.props.history.push(subsequentUrl);
            return;
        }

        //retrieve data from redux store for current page
        var cariPageDataCopy = null;
        switch (currentPageNum) {
            case 1:
                cariPageDataCopy = this.props.cariPage1Data;
                break;
            case 2:
                cariPageDataCopy = this.props.cariPage2Data;
                break;
            case 3:
                cariPageDataCopy = this.props.cariPage3Data;
                break;
            case 4:
                cariPageDataCopy = this.props.cariPage4Data;
                break;
            default:
        }

        if (!isEmpty(cariPageDataCopy)) {

            //remove page num from post data
            delete cariPageDataCopy['page_num'];

            //post url
            var savePageDataUrl = cari_api_save_form_page_base_url + currentPageNum;

            //get email and application id and post data to post 
            var currentEmail = this.props.activeVerifiedLoginUserData.email;
            var currentApplicationId = this.props.activeApplicationData.application_id;
            var currentToken = this.props.activeVerifiedLoginUserData.token;

            //set post data and add email, token and application id
            var form_data = new FormData();
            form_data.append("email", currentEmail);
            form_data.append("application_id", currentApplicationId);
            form_data.append("token", currentToken);
            form_data.append("postData", JSON.stringify(cariPageDataCopy));

            var usedOwnEmailAsReference = false;

            for(var i = 0; i < cariPageDataCopy.length; i++) {
                if(cariPageDataCopy[i]['email'] == currentEmail) {
                    usedOwnEmailAsReference = true;
                }
            }

            if(usedOwnEmailAsReference) {
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Invalid Email Address",
                    contentText: "You may not use your own email address for a reference. Please enter your reference's email address."
                });
            }
            else {
                fetch(savePageDataUrl, {
                    method: 'POST',
                    body: form_data,
                    headers: {
                        'Accept': 'application/json',
                    }
                }).then((response) => {
                    var responseHttpCode = response.status;
                    //good request
                    if (responseHttpCode === 200) {
                        return response.json();
                    }
                    //404 api not found, allows user to retry
                    else if (responseHttpCode === 404) {
                        this.props.openCariModal({
                            modalId: "errorModal",
                            title: "Bad Request, please try again.",
                        });
                    }
                    //invalid data and not authorized, reset cari data
                    else {
                        this.props.openCariModal({
                            modalId: "errorModal",
                            title: "User Session is invalid or has expired, please login again.",
                            callBackFuncOnOk: () => {
                                this.props.resetCariActiveData();
                            }
                        });
                    }
                }).then(json => {
                    //successfully processed request
                    if (!isEmpty(json)
                        && !isEmpty(json.status)
                        && json.status 
                        && !isEmpty(JSON.parse(json.message))
                        && JSON.parse(json.message).saveComplete
                    ) {
                        var json_data = JSON.parse(json.message);

                        //save first name and last name to redux store for active user data if it is the first page and the first name and last name is not empty
                        if (currentPageNum === 1
                            && !isEmpty(cariPageDataCopy.first_name)
                            && !isEmpty(cariPageDataCopy.last_name)
                        ) {
                            var copyUserActiveData = cloneObject(this.props.activeUserData);
                            copyUserActiveData.first_name = cariPageDataCopy.first_name;
                            copyUserActiveData.last_name = cariPageDataCopy.last_name;
                            this.props.setCariActiveUserData(copyUserActiveData);
                        }

                        //redirect to next page
                        this.props.history.push(subsequentUrl);
                    }
                    //if api returns no data
                    else {
                        // this.props.openCariModal({
                        //     modalId: "errorModal",
                        //     title: "Failed to save page data, please try again.",
                        // });
                    }
                })
                //if api is not found
                .catch((error) => {
                    console.log(error);
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Something went wrong, please try again.",
                    });
                });
            }
        }
        else {
            //if the api is not found, pop up a modal to show error message
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Failed to retrieve data, please try again.",
            });
        }
    }

    componentDidMount() {
        this.setState({
            mounted: true
        });
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    render() {
        return (
            <div>
                <Stepper 
                    stepperOptions={this.state.stepperOptions} 
                    activeIndex={(!isEmpty(this.props.page_num) ? this.props.page_num : 1)} 
                    selectFunc={this.handleOnClickSavePageData}
                />
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariAppFormStepper));